import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AgreementBalance, _PlanAnualdeCuentas } from "../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { SelectMonths } from "../select/SelectMonths";





interface Props {
    IDAdquisitionItem: number;
}

export const PlanAnualdeCuentas = ({ IDAdquisitionItem }: Props) => {

    const plananualdecuentas = useDataBean(_PlanAnualdeCuentas);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [IDAdquisitionItem])


    const getLista = () => {

        plananualdecuentas.instance.getAdquisitionItemPACCatalogPorPropiedades({ State: 1, IDAdquisitionItem: IDAdquisitionItem }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        plananualdecuentas.setBean({
            State: 1,
            IDAdquisitionItem: IDAdquisitionItem,
            IDEmployee: _single.getAccountID(),
            LastUpdate: _single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        plananualdecuentas.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        plananualdecuentas.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDAdquisitionItem', visible: true },
        { title: 'Mes', property: 'MonthPAC', visible: true },
        { title: 'Valor', property: 'EstimateValue', visible: true },
        { title: 'Ultima Modificación', property: 'LastUpdate', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Plan Anual de Cuentas">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={plananualdecuentas.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">


                                <div className="col-md-12">

                                    <SelectMonths idSelector={plananualdecuentas.bean.MonthPAC} onChange={(e) => { plananualdecuentas.setBean({ ...plananualdecuentas.bean, "MonthPAC": e }) }}></SelectMonths>
                                </div>
                                <div className="col-md-12">
                                    <label>Valor</label>
                                    <input type='text' name="EstimateValue" className="form-control" value={plananualdecuentas.bean.EstimateValue} onChange={plananualdecuentas.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}